<div class="card">
    <!--<div class="card-header">
        <h3>Insurance Information Form</h3>
    </div>-->

    <div class="card-body">
        <form [formGroup]="insuranceForm" (ngSubmit)="onSubmit()">

            <!-- Payers Dropdown (Full Width) -->
            <div class="field mb-4">
                <label for="payers" class="block mb-2">Payors <span class="text-red-500">*</span></label>
                <p-dropdown id="payers" appAddFormAttributes
                            formControlName="payerId"
                            [options]="payers"
                            optionLabel="payerName"
                            optionValue="id"
                            placeholder="Select a Payer"
                            styleClass="w-full">
                </p-dropdown>

            </div>

            <!-- Policy Number and Group Number in one row -->
            <div class="grid mb-3">
                <div class="col-12 md:col-6">
                    <div class="field">
                        <label for="policyNumber" class="block mb-2">Policy Number <span class="text-red-500">*</span></label>
                        <input pInputText appAddFormAttributes
                               id="policyNumber"
                               formControlName="policyNumber"
                               placeholder="Enter Policy Number"
                               class="w-full"
                                />

                    </div>
                </div>

                <div class="col-12 md:col-6">
                    <div class="field">
                        <label for="groupNumber" class="block mb-2">Group Number <span class="text-red-500">*</span></label>
                        <input pInputText appAddFormAttributes
                               id="groupNumber"
                               formControlName="groupNumber"
                               placeholder="Enter Group Number"
                               class="w-full"
                              />

                    </div>
                </div>
            </div>

            <!-- Effective Date and Expiry Date in one row -->
            <div class="grid mb-3">
                <div class="col-12 md:col-6">
                    <div class="field">
                        <label for="effectiveDate" class="block mb-2">Effective Date <span class="text-red-500">*</span></label>
                        <p-calendar id="effectiveDate" appAddFormAttributes
                                    formControlName="effectiveDate"
                                    dateFormat="mm/dd/yy"
                                    placeholder="Select Effective Date"
                                    styleClass="w-full" appendTo="body"
                                    [showIcon]="true">
                        </p-calendar>

                    </div>
                </div>

                <div class="col-12 md:col-6">
                    <div class="field">
                        <label for="policyExpiryDate" class="block mb-2">Policy Expiry Date <span class="text-red-500">*</span></label>
                        <p-calendar id="policyExpiryDate" appAddFormAttributes
                                    formControlName="policyExpiryDate"
                                    dateFormat="mm/dd/yy"
                                    placeholder="Select Expiry Date"
                                    styleClass="w-full" appendTo="body"
                                    [showIcon]="true">
                        </p-calendar>

                    </div>
                </div>
            </div>

            <!-- COB Fields - All three in one row on larger screens -->
            <div class="grid mb-4">
                <div class="col-12 md:col-4">
                    <div class="field">
                        <label for="payorType" class="block mb-2">Payor Type <span class="text-red-500">*</span></label>
                        <p-dropdown pInputText id="payorType" appAddFormAttributes
                                    formControlName="payorType"
                                    placeholder="Select Payor Type"
                                    [options]="payorTypes"
                                    optionValue="value"
                                    optionLabel="label"
                                    styleClass="w-full"></p-dropdown>


                    </div>
                </div>

            </div>

            <!-- Action Buttons -->
            <div class="flex flex-wrap gap-2 justify-content-start mt-5">
                <p-button label="Submit"
                          icon="pi pi-check"
                          type="submit"
                          styleClass="p-button-success">
                </p-button>


            </div>



        </form>
    </div>
</div>
